import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal/Modal";
import TopNavigation from "../../components/TopNavigation/index";
import { getToken } from "../../utils/common";
import { useForm } from "react-hook-form";
import LoadingIcon from "../../components/Loading/LoadingIcon";

export default function WebCheckIn() {
  const [id, setId] = useState();
  const [data, setData] = useState([]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.id) {
      setId(params.id);
      fetchBookingDetails(params.id);
    } else window.location = "/admin/bookings";
  }, []);

  const fetchBookingDetails = (id) => {
    fetch(process.env.REACT_APP_API_ENDPOINT + `/group_portal/bookings/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw Error("Verification failed");
      })
      .then((response) => {
        setData(response);
      })
      .catch((err) => console.log(err));
  };

  const RenderGuest = ({ guest, room, roomIndex }) => {
    const [showModal, setShowModal] = useState(false);
    const [terms, setTerms] = useState(false);
    const [covid, setCovid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingDeclaration, setLoadingDeclaration] = useState(false);
    const [isHealthDocFilled, setIsHealthDocFilled] = useState(null);
    const [saveError, setSaveError] = useState(false);
    const [healthDeclarationDoc, setsealthDeclarationDoc] = useState(
      guest.declaration_accepted ? guest.health_declaration_doc_url : null
    );
    const [boardingPass, setBoardingPass] = useState(
      guest.web_checkin_done ? guest.boarding_pass_doc_url : null
    );
    const [declarationAccepted, setDeclarationAccepted] = useState(
      guest.declaration_accepted ? true : false
    );
    const [questions, setQuestions] = useState([
      {
        question_no: 1,
        question: "Have you recently developed cough (dry or productive)",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 2,
        question: "Fever (or feeling feverish)",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 3,
        question: "General weakness",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 4,
        question: "Generalized muscle ache",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 5,
        question: "Sudden loss of smell and/or taste",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 6,
        question: "Any respiratory distress",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 7,
        question:
          "In the last 14 days before your journey, were you in contact with anyone diagnosed with COVID-19 inspection?",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 8,
        question:
          "In the last four hours before temperature check, have you consumed antipyretics or other analgesics?",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 9,
        question:
          "In the last 14 days before your journey, list the cities and countries you have visited and indicate the duration of your stay in each one",
        question_type: "2d_array",
        answer: [
          {
            row: 1,
            columns: [
              {
                name: "Place",
                value: null,
              },
              {
                name: "Arrival",
                value: null,
              },
              {
                name: "Departure",
                value: null,
              },
            ],
          },
        ],
      },
      {
        question_no: 10,
        question: "I/we am/are not residing in any containment zone.",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 11,
        question: "I/we am are not under quarantine.",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 12,
        question:
          "I/we develop any of the above-mentioned symptoms I shall contact the concerned health authorities immediately.",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 13,
        question: "I/we have not tested COVID-19 positive in last two months.",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 14,
        question: "I /we are eligible to travel as per the extant norms.",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 15,
        question:
          "I/we make my mobile number/contact details available to the cruise lines whenever required by them",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 16,
        question:
          "I/we undertake to adhere to the health protocol prescribed by the destination State/UT.",
        question_type: "boolean",
        answer: null,
      },
      {
        question_no: 17,
        question: "Assessment Section",
        question_type: "2d_array",
        answer: [
          {
            row: 1,
            columns: [
              {
                name: "Temperature Check",
                value: null,
              },
              {
                name: "Other Vital Signs",
                value: null,
              },
            ],
          },
        ],
      },
    ]);
    const resetQuestions = () => {
      setQuestions([
        {
          question_no: 1,
          question: "Have you recently developed cough (dry or productive)",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 2,
          question: "Fever (or feeling feverish)",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 3,
          question: "General weakness",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 4,
          question: "Generalized muscle ache",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 5,
          question: "Sudden loss of smell and/or taste",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 6,
          question: "Any respiratory distress",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 7,
          question:
            "In the last 14 days before your journey, were you in contact with anyone diagnosed with COVID-19 inspection?",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 8,
          question:
            "In the last four hours before temperature check, have you consumed antipyretics or other analgesics?",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 9,
          question:
            "In the last 14 days before your journey, list the cities and countries you have visited and indicate the duration of your stay in each one",
          question_type: "2d_array",
          answer: [
            {
              row: 1,
              columns: [
                {
                  name: "Place",
                  value: null,
                },
                {
                  name: "Arrival",
                  value: null,
                },
                {
                  name: "Departure",
                  value: null,
                },
              ],
            },
          ],
        },
        {
          question_no: 10,
          question: "I/we am/are not residing in any containment zone.",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 11,
          question: "I/we am are not under quarantine.",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 12,
          question:
            "I/we develop any of the above-mentioned symptoms I shall contact the concerned health authorities immediately.",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 13,
          question:
            "I/we have not tested COVID-19 positive in last two months.",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 14,
          question: "I /we are eligible to travel as per the extant norms.",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 15,
          question:
            "I/we make my mobile number/contact details available to the cruise lines whenever required by them",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 16,
          question:
            "I/we undertake to adhere to the health protocol prescribed by the destination State/UT.",
          question_type: "boolean",
          answer: null,
        },
        {
          question_no: 17,
          question: "Assessment Section",
          question_type: "2d_array",
          answer: [
            {
              row: 1,
              columns: [
                {
                  name: "Temperature Check",
                  value: null,
                },
                {
                  name: "Other Vital Signs",
                  value: null,
                },
              ],
            },
          ],
        },
      ]);
    };
    const updateQuestion = (index, value, subQuestion) => {
      let tempQuestions = questions;
      if (index === 8 || index === 16) {
        tempQuestions[index].answer[0].columns[subQuestion].value = value;
      } else {
        tempQuestions[index].answer = value;
        setQuestions(tempQuestions);
      }
      console.log(tempQuestions);
    };

    const checkForm = () => {
      const answer = questions.map((question) => {
        if (question.question_no !== 9 || question.question_no !== 17) {
          if (question.answer === null) {
            setIsHealthDocFilled(false);
            return false;
          }
        }
        // if (question.question_no === 9) {
        //   // const verify =  question.answer[0].columns.map((col) => {
        //   //   if (col.value === null) {
        //   //     return false;
        //   //   } else return true
        //   // });
        //   // if(!verify){
        //   //   setIsHealthDocFilled(false);
        //   //   return false;
        //   // }
        //   // return true
        // } else if (question.question_no === 17) {
        //   // const verify =  question.answer[0].columns.map((col) => {
        //   //   if (col.value === null) {
        //   //     return false;
        //   //   } else return true
        //   // });
        //   // if(!verify){
        //   //   setIsHealthDocFilled(false);
        //   //   return false;
        //   // }
        // } else {
        //   if (question.answer === null) {
        //     setIsHealthDocFilled(false);
        //     return false;
        //   }
        // }
      });
      return answer;
    };
    const saveDeclaration = () => {
      const isFormValid = checkForm();
      console.log(!isFormValid.some((item) => item === false))
      if (!isFormValid.some((item) => item === false)) {
        setIsHealthDocFilled(true)
        setLoadingDeclaration(true);
        const data = {
          booking_id: id,
          guest_id: guest.id,
          declaration_accepted: true,
          question_responses: questions,
        };
        fetch(
          process.env.REACT_APP_API_ENDPOINT +
          `/group_portal/bookings/save_declaration`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
          }
        )
          .then((response) => {
            setLoadingDeclaration(false);
            if (response.ok) {
              return response.json();
            }
            throw Error("Verification failed");
          })
          .then((response) => {
            if (response.status === "success") {
              setDeclarationAccepted(true);
              setShowModal(false);
            }
          })
          .catch((err) => console.log(err));
      }
    };
    const updateGuest = () => {
      const data = {
        booking_id: id,
        guest_id: guest.id,
        // declaration_accepted: true,
        // question_responses: questions,
      };
      setLoading(true);
      setSaveError(false);
      fetch(
        process.env.REACT_APP_API_ENDPOINT +
        `/group_portal/bookings/update_guest`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => {
          setLoading(false);
          if (response.ok) {
            return response.json();
          }
          throw Error("Verification failed");
        })
        .then((response) => {
          console.log(response);
          if (response.status === "success") {
            setDeclarationAccepted(true);
            setBoardingPass(response.data.boarding_pass_doc_url);
            setsealthDeclarationDoc(response.data.health_declaration_doc_url);
          } else if (response.status === "failure") {
            setSaveError(response.message);
          }
        })
        .catch((err) => console.log(err));
    };
    const RenderQuestion = ({ question, index }) => {
      const [answer, setAnswer] = useState(question.answer);
      if (question.question_no === 9) {
        return (
          <div className="grid grid-cols-12 gap-2 mb-2" key={index}>
            <p className="col-span-10 ml-5 mb-1">
              <li>{`${question.question}`}</li>
            </p>
            <div className="grid grid-cols-3 gap-4 col-span-10 mx-4">
              <input
                type="text"
                placeholder="Enter place"
                className="w-full p-2 rounded border"
                onChange={(event) => {
                  updateQuestion(index, event.target.value, 0);
                }}
                value={question.answer[0].columns[0].value}
              />
              <input
                type="date"
                placeholder="Date of Arrival"
                className="w-full p-2 rounded border bg-white"
                onChange={(event) => {
                  updateQuestion(index, event.target.value, 1);
                }}
                value={question.answer[0].columns[1].value}
              />
              <input
                type="date"
                placeholder="Date of Departure"
                className="w-full p-2 rounded border bg-white"
                onChange={(event) => {
                  updateQuestion(index, event.target.value, 2);
                }}
                value={question.answer[0].columns[2].value}
              />
            </div>
          </div>
        );
      } else if (question.question_no === 17) {
        return (
          <div className="grid grid-cols-12 gap-2 mb-2" key={index}>
            <p className="col-span-10 ml-5 mb-1">
              <li>{`${question.question}`}</li>
            </p>
            <div className="grid grid-cols-3 gap-4 col-span-10 mx-4">
              <div>
                <p>Temperature Check</p>
                <input
                  type="text"
                  placeholder="Enter temperature"
                  className="w-full p-2 rounded border"
                  onChange={(event) => {
                    updateQuestion(index, event.target.value, 0);
                  }}
                  value={question.answer[0].columns[0].value}
                />
              </div>
              <div className="col-span-2">
                <p>Other Vital Signs</p>
                <input
                  type="text"
                  placeholder="Other Vital Signs"
                  className="w-full p-2 rounded border bg-white"
                  onChange={(event) => {
                    updateQuestion(index, event.target.value, 1);
                  }}
                  value={question.answer[0].columns[1].value}
                />
              </div>
            </div>
          </div>
        );
      } else
        return (
          <div className="grid grid-cols-12 gap-2 mb-2" key={index}>
            <p className="col-span-10 ml-5">
              <li>{`${question.question}`}</li>
            </p>
            <div className="col-1">
              {/* {question.answer === "Yes" ? (
              <i class="far fa-check-square"></i>
            ) : (
              <i class="far fa-square" onClick={()=>{updateQuestion(index,"Yes")}}></i>
            )} */}
              <input
                type="checkbox"
                name={`question${question.question_no}`}
                id={`question${question.question_no}`}
                checked={answer === "Yes" ? true : false}
                onChange={() => {
                  setAnswer("Yes");
                  updateQuestion(index, "Yes");
                }}
              />
            </div>
            <div className="col-1">
              <input
                type="checkbox"
                name={`question${question.question_no}`}
                id={`question${question.question_no}`}
                checked={answer === "No" ? true : false}
                onChange={() => {
                  setAnswer("No");
                  updateQuestion(index, "No");
                }}
              />
            </div>
          </div>
        );
    };
    return (
      <>
        <div className="col-span-4">
          <h4 className="capitalize text-j-magenta font-bold mb-3 text-lg">{`Guest- ${guest.name}`}</h4>
          <div className="mb-2">
            <p className="mb-1 text-j-magenta">Country</p>
            <p className="rounded border p-2">{guest.country}</p>
          </div>
          <div className="mb-2">
            <p className="mb-1 text-j-magenta">State</p>
            <p className="rounded border p-2">{guest.state}</p>
          </div>
          <div className="mb-2">
            <p className="mb-1 text-j-magenta">Meal Type</p>
            <p className="rounded border p-2">{guest.meal}</p>
          </div>
          <div className="mb-2">
            <p className="mb-1 text-j-magenta">Cabin</p>
            <p className="rounded border p-2">{room.category}</p>
          </div>
          <div className="mb-2">
            <p className="mb-1 text-j-magenta">Room Number</p>
            <p className="rounded border p-2">{room.number}</p>
          </div>
          {/* <div className="mb-2">
          <p className="mb-1 text-j-magenta">Identification Type</p>
          <p className="rounded border p-2">{guest.meal}</p>
        </div> */}
          {/* {declarationAccepted ? (
            <p className="text-success italic text-sm">
              {boardingPass
                ? "Web check in completed"
                : "Successfully submitted declaration"}
            </p>
          ) : (
            <div className="text-center">
              <button
                className="my-2 bg-magenta p-1 px-5 rounded-lg text-white"
                onClick={() => setShowModal(true)}
              >
                Health Declaration Form*
              </button>
            </div>
          )} */}

          {!boardingPass && (
            <div className="mt-4">
              <input
                type="checkbox"
                name={`covid-${guest.id}`}
                id={`covid-${guest.id}`}
                checked={covid}
                onChange={() => {
                  setCovid(!covid);
                }}
              />
              <label for={`covid-${guest.id}`} className="pl-2 italic">
                I Agree that I have not been tested COVID positive
              </label>
            </div>
          )}
          {declarationAccepted && <button
            download="Boarding Pass.pdf"
            className={`my-2 p-2 rounded bg-magenta text-white w-full px-6 mx-auto`}
            onClick={() => window.open(healthDeclarationDoc)}
          >
            Download Health Declaration
          </button>}
          {!boardingPass ? (
            <button
              className={`my-2 p-2 rounded bg-magenta text-white w-full px-6 mx-auto ${!covid && "opacity-60 cursor-not-allowed"
                }`}
              onClick={() => updateGuest()}
              disabled={!covid}
            >
              {loading ? <LoadingIcon /> : "Save Guest"}
            </button>
          ) : (
            <button
              download="Boarding Pass.pdf"
              className={`my-2 p-2 rounded bg-magenta text-white w-full px-6 mx-auto`}
              onClick={() => window.open(boardingPass)}
            >
              Download Boarding Pass
            </button>
          )}
          {saveError && <p className="text-danger text-center">{saveError}</p>}
        </div>

        <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          className="HealthModal"
        >
          <div className="p-5">
            <h3 className="text-center text-xl my-4 font-bold">
              Health Declaration Form
            </h3>
            <p className="text-center mb-4">
              In the last 8 days before your journey, have you had any of the
              symptoms? (Please mark yes or no against each symptom)
            </p>
            <div>
              <div className="grid grid-cols-12 gap-2">
                <p className="col-span-10"></p>
                <p className="font-bold">YES</p>
                <p className="font-bold">NO</p>
              </div>
              <ol>
                {questions.map((question, index) => (
                  <RenderQuestion question={question} index={index} />
                ))}
              </ol>
            </div>
            <div className="mt-4">
              <input
                type="checkbox"
                name={`terms`}
                id={`terms`}
                checked={terms}
                onChange={() => {
                  setTerms(!terms);
                }}
              />
              <label for="terms" className="pl-2 italic">
                {" "}
                I Accept the terms & conditions
              </label>
            </div>
            <div className="text-center mt-4">
              {isHealthDocFilled === false && (
                <p className="text-danger">Please enter all the details</p>
              )}
              <button
                type="button"
                className={`my-2 p-2 w-32 rounded bg-magenta text-white px-6 mx-auto ${!terms && "opacity-60 cursor-not-allowed"
                  }`}
                disabled={!terms}
                onClick={() => saveDeclaration()}
              >
                {loadingDeclaration ? <LoadingIcon /> : "Sumbit"}
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  };
  return (
    <>
      <div className="h-full">
        <main className=" h-full m-6">
          <div className="pt-2">
            <TopNavigation
              icon="fas fa-home text-sm text-gray-500"
              name="Web Check In"
            />
          </div>
          {/* <div>
                            <DashboardCard />
                        </div> */}
          <div className="mt-6 mr-2 p-4">
            <h1 className="text-xl font-bold text-j-magenta mb-4">
              Web Check In
            </h1>
            <div className="grid grid-cols-12 gap-4">
              {data &&
                data.rooms &&
                data.rooms.map((room) => {
                  return room.guests.map((guest, i) => (
                    <RenderGuest guest={guest} key={guest.id} room={room} roomIndex={i} />
                  ));
                })}
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
